import { render } from "./IphoneSwitch.vue?vue&type=template&id=0dacc4f4&scoped=true"
import script from "./IphoneSwitch.vue?vue&type=script&lang=js"
export * from "./IphoneSwitch.vue?vue&type=script&lang=js"

import "./IphoneSwitch.vue?vue&type=style&index=0&id=0dacc4f4&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dacc4f4"]])

export default __exports__